import { FC } from 'react'
import { Typography, Grid } from '@mui/material'
import { useAppDispatch } from '../../../hooks'
import { getFormattedEndDateString, getFormattedStartDateString } from '../../../utils'
import { DateRangeSelector } from '../../../components'
import { getBillsPaymentChartDataAction } from './actions'

const BillsPaymentReportHeader: FC = () => {
  const dispatchAction = useAppDispatch()

  const handleDateRangeChange = (startDate: Date, endDate: Date) => {
    const start = getFormattedStartDateString(startDate, true)
    const end = getFormattedEndDateString(endDate, true)
    dispatchAction(getBillsPaymentChartDataAction(start, end))
  }

  return (
    <>
      <Grid container alignItems="center">
        <Grid item md={5}>
          <Typography variant="h3" component="h3" gutterBottom pl={2.5}>
            Month-Wise Bills/Payment
          </Typography>
        </Grid>
        <Grid
          md={7}
          item
          sx={{
            width: 250,
            textAlign: 'right',
            display: 'flex',
            justifyContent: 'right',
            alignItems: 'center',
          }}
        >
          <div style={{ marginBottom: -20 }}>
          <DateRangeSelector
            onChange={handleDateRangeChange}
            defaultPreset="currentFinYear"
            showViewButton={false}
            triggerOnMount={true}
            maxRangePeriodMonths={24}
          />
          </div>
        </Grid>
      </Grid>
    </>
  )
}

export default BillsPaymentReportHeader
